var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalWinBgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 127,
    viewBox: "0 0 247 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.535 -43.7282C187.457 -29.1779 177 -12.6243 165.369 2.53166C153.734 17.6857 140.153 31.9993 126.443 37.9466C112.062 44.1834 99.8748 40.3021 86.1 43.0332C63.113 47.5927 38.2558 69.7024 14.764 89.6459C-4.87949 106.324 -26.435 122.815 -45.2117 126.682L-84.9837 103.28L82.3651 -181.139L246.984 -84.2797C230.505 -75.1687 213.953 -61.1001 199.535 -43.7282Z",
    fill: "#3D866B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWinBgDark);
export default __webpack_public_path__ + "static/media/modal_win_bg_dark.869f285a9896545aae705e7de36ceabd.svg";
export { ForwardRef as ReactComponent };